import React from 'react';

import './contribute.scss';

const Contribute: React.FC = () => (
    <div className="contribute">
        <a
            href="https://github.com/Toofifty/make-cable"
            className="contribute__button"
            target="__blank"
        >
            Contribute on Github
        </a>
    </div>
);

export default Contribute;
